import { default as Core } from './Core'
import { default as Events } from './Events'

Events.Init()

export default {
    Core,
    Events
}